import { createAction, props } from "@ngrx/store";

export const fetchCampaignAffiliates = createAction(
  "[Campaign Affiliates] Fetch",
  props<{ page, campaignID, filterOptions }>()
);

export const fetchCampaignAffiliatesSuccess = createAction(
  "[Campaign Affiliates] Fetch Success",
  props<{ campaignAffiliates }>()
);

export const fetchCampaignAffiliatesFailure = createAction(
  "[Campaign Affiliates] Fetch Faild",
  props<{ error }>()
);

export const fetchCampaignAffiliatesByComGroup = createAction(
  "[Campaign Affiliates] Fetch By Com Group",
  props<{ page, campaignID, commissionGroupID }>()
);

export const fetchCampaignAffiliatesByComGroupSuccess = createAction(
  "[Campaign Affiliates] Fetch By Com Group Success",
  props<{ campaignAffiliates }>()
);

export const fetchCampaignAffiliatesByComGroupFailure = createAction(
  "[Campaign Affiliates] Fetch By Com Group Faild",
  props<{ error }>()
);

export const getCampaignAffiliate = createAction(
  "[Campaign Affiliates] Get",
  props<{ id }>()
);

export const getCampaignAffiliateSuccess = createAction(
  "[Campaign Affiliates] Get Success",
  props<{ campaignAffiliate }>()
);

export const getCampaignAffiliateFailure = createAction(
  "[Campaign Affiliates] Get Failure",
  props<{ error }>()
);

export const deleteCampaignAffiliate = createAction(
  "[Campaign Affiliates] Delete",
  props<{ id }>()
);

export const deleteCampaignAffiliateSuccess = createAction(
  "[Campaign Affiliates] Delete Success",
  props<{ id }>()
);

export const deleteCampaignAffiliateFailure = createAction(
  "[Campaign Affiliates] Delete Failure",
  props<{ error }>()
);

export const addCampaignAffiliate = createAction(
  "[Campaign Affiliates] Add",
  props<{ campaignAffiliate }>()
);

export const addCampaignAffiliateSuccess = createAction(
  "[Campaign Affiliates] Add Success",
  props<{ campaignAffiliate }>()
);

export const addCampaignAffiliateFailure = createAction(
  "[Campaign Affiliates] Add Failure",
  props<{ error }>()
);

export const updateCampaignAffiliate = createAction(
  "[Campaign Affiliates] Update",
  props<{ campaignAffiliate }>()
);

export const updateCampaignAffiliateSuccess = createAction(
  "[Campaign Affiliates] Update Success",
  props<{ campaignAffiliate }>()
);

export const updateCampaignAffiliateFailure = createAction(
  "[Campaign Affiliates] Update Failure",
  props<{ error }>()
);

export const unsubscribeCampaign = createAction(
  "[Campaign Affiliate] unsubscribe",
  props<{id}>()
);

export const unsubscribeCampaignSuccess = createAction(
  "[Campaign Affiliate] unsubscribe success",
  props<{id}>()
);

export const unsubscribeCampaignFailure = createAction(
  "[Campaign Affiliate] unsubscribe failure",
  props<{error}>()
);
